import { useQuery } from "react-query";
import { getReports } from "../../../MyApi/reports";
import { oredersStatusConfig } from "../config";
import EmptyList from "../../../Components/UI/messages/emptyList";
import HeaderBar from "../../../Components/UI/headerbar";
import StatsCard from "../../../Components/UI/staticsCard";
import FilterBar from "../../../Components/UI/filterbar";
import { useState } from "react";
import OrdersReportsTab from "../../../Components/reports/ordersreports";

const OrdersReportPage = () => {
  const [filters, setFilters] = useState({
    store: "",
    date: "",
    status: "",
    city: "",
    categories: "",
  });

  const filtersConfig = {
    status: "status",
    store: "store",
    date: "date",
    categories: "categories",
    city: "city",
  };

  const { data, isLoading, isFetching, error } = useQuery(
    ["getReports", filters],
    () => getReports(filters),
  );
  const reports = data?.data || {};

  const getStatsConfig = () => {
    return oredersStatusConfig(reports);
  };

  if (reports.length === 0) {
    return <EmptyList />;
  }
  return (
    <div>
      <HeaderBar
        title={"إدارة التقارير"}
        content={"تتبع وتحليل بيانات الأداء والمبيعات والعمليات"}
      />

      <div className="row">
        {getStatsConfig().map((status, i) => (
          <div className="col-md" key={i}>
            <StatsCard {...status} home={true} isLoading={isLoading} />
          </div>
        ))}
      </div>

      <FilterBar
        filtersConfig={filtersConfig}
        filters={filters}
        setFilters={setFilters}
      />

      <OrdersReportsTab statsWidget={reports} isLoading={isLoading} />
    </div>
  );
};

export default OrdersReportPage;
